var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vs-input-number',{staticStyle:{"width":"fit-content"},attrs:{"size":"medium","max":"999","min":"0","color":"dark"},on:{"input":function($event){return _vm.$emit('ChangeQuantity', {
        id: _vm.id,
        quantity: _vm.tmpQuantity,
      })}},model:{value:(_vm.tmpQuantity),callback:function ($$v) {_vm.tmpQuantity=$$v},expression:"tmpQuantity"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }